import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import LabelValue from '../../LabelValue';
import LabelLink from '../../LabelLink';
import { Vehicle } from '../../../data/models/vehicle.model';
import { useBooleanStatus } from '../../../hooks/useBooleanStatus';
import { useActiveStatus } from '../../../hooks/useActiveStatus';
import { useAppSelector } from '../../../hooks/useAppSelector';
import * as referenceSlice from '../../../data/reference.slice';
import * as providerSlice from '../../../data/provider.slice';

interface AttributesProps {
  vehicle: Vehicle | null;
}

export default function Attributes(props: AttributesProps) {
  const { t } = useTranslation('common');
  const { vehicle } = props;

  const attributes = useAppSelector(referenceSlice.selectVehicleAttributeTypes);

  const getAttributeValue = (attrTypeId: number) => {
    const attribute = (vehicle?.vehicleAttributes || []).find(
      (attr) => attr.vehicleAttributeTypeID === attrTypeId,
    );
    return attribute && attribute.vehicleAttributeState == 'active'
      ? `${attribute.quantity}`
      : '0';
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={3} md={6} sm={12}>
          <LabelLink
            label={t('common.provider')}
            value={vehicle?.transportationProvider?.transportationProviderName}
            link={`/providers/${vehicle?.transportationProviderID}`}
            underline="always"
          />
        </Grid>
        {attributes.map((attr) => (
          <Grid item lg={3} md={6} sm={12} key={attr.vehicleAttributeTypeID}>
            <LabelValue
              label={attr.vehicleAttributeTypeName}
              value={getAttributeValue(attr.vehicleAttributeTypeID)}
            />
          </Grid>
        ))}
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('common.status')}
            value={useActiveStatus(vehicle?.vehicleState)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('common.clearToTransport')}
            value={useBooleanStatus(vehicle?.isClearToTransport)}
          />
        </Grid>
      </Grid>
    </>
  );
}
